export default "/angle-down.d18a41bb6d0a4af19bb5f20a3436dd05.svg";